export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11494.0735d509.jpg";